import { Timestamp } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface TimeLeftUntilProps {
  timestamp: Timestamp;
}

const calculateTimeLeft = (timestamp: Timestamp): string => {
  const now = new Date();
  const targetDate = timestamp.toDate();
  const difference = targetDate.getTime() - now.getTime();

  if (difference <= 0) return '0 hrs';

  const hours = Math.floor(difference / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}:${minutes < 10 ? '0' : ''}${minutes} hrs`;
};

const TimeLeftUntil: React.FC<TimeLeftUntilProps> = ({ timestamp }) => {
  const [timeLeft, setTimeLeft] = useState<string>(() => calculateTimeLeft(timestamp));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft(calculateTimeLeft(timestamp));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timestamp]);

  return (
    <div className="flex space-x-[0.5rem]">
      <AccessTimeIcon className="text-gray-450" />
      <div>{timeLeft}</div>
    </div>
  );
};

export default TimeLeftUntil;
